import clsx from 'clsx';
import { type ReactNode } from 'react';

import { ExpandableList, ExpandableListControl, ExpandableListItems } from '~/ui/ExpandableList';
import { TransactionBlockCard } from '~/ui/TransactionBlockCard';

interface ProgrammableTxnBlockCardProps {
	items: ReactNode[];
	itemsLabel: string;
	defaultItemsToShow: number;
	noExpandableList?: boolean;
	count?: number;
	initialClose?: boolean;
}

export function ProgrammableTxnBlockCard({
	items,
	itemsLabel,
	defaultItemsToShow,
	noExpandableList,
	count,
	initialClose,
}: ProgrammableTxnBlockCardProps) {
	if (!items?.length) {
		return null;
	}

	const cardTitle = count ? `${count} ${itemsLabel}` : itemsLabel;
	return (
		<TransactionBlockCard
			collapsible
			initialClose={initialClose}
			title={cardTitle}
			isShowChevronRight
		>
			<ExpandableList items={items} defaultItemsToShow={defaultItemsToShow} itemsLabel={itemsLabel}>
				<div
					className={clsx(
						'flex flex-col gap-6 overflow-y-auto px-5',
						!noExpandableList && 'max-h-[300px]',
					)}
				>
					{noExpandableList ? <>{items}</> : <ExpandableListItems />}
				</div>

				{items.length > defaultItemsToShow && (
					<div className="mt-6">
						<ExpandableListControl />
					</div>
				)}
			</ExpandableList>
		</TransactionBlockCard>
	);
}
